<template>
  <el-menu :default-active="$route.path" class="aside-cont navbar g-elmenu"
           active-text-color="#fff" text-color="#fff" router
           :unique-opened="true" :collapse="isCollapse" style="width: 202px;font-size: 12px;">
    <template v-for="(item,index) in $router.options.routes"
              v-if="!item.hidden&&$checkPermissions(item.permission)">
      <el-submenu :index="index+''" v-if="!item.leaf">
        <template slot="title"><i
          :class="'iconfont '+ item.icon+' '+((netaddress===item.children[0].path&&isCollapse)?'actived':'')"></i>
          <span>{{item.name}}</span><!--<p>1</p>--></template>
        <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden&&$checkPermissions(child.permission)"
                      @click.native="shows(child.path)">
          {{child.name}}
        </el-menu-item>
      </el-submenu>
      <el-menu-item  v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"
                    :class="netaddress==item.children[0].path ? 'is-active':'' "
                    @click.native="shows(item.children[0].path)">
        <!--<i :class="'iconfont '+ item.icon"></i>--><span>{{item.name}}</span><!--<p>1</p>--></el-menu-item>
    </template>
  </el-menu>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    data() {
      return {
        url: '',
        query: '',
        netaddress: '',
        isCollapse: false,
        sideList: [{
          path: '/index',
          name: '系统操作面板',
          hidden: false,
          leaf: true,
          icon: 'icon-52',//图标样式class
          children: [
            {path: "/mediaSystem/systemIndex", name: '系统操作面板'},
          ],
          permission: "index_module"
        }],
      }
    },
    // props: ['number', 'type', 'size', 'list'],
    created() {

    },
    mounted() {
    },
    computed: {},
    methods: {
      shows() {
      },
    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .g-elmenu>.el-menu-item{
    text-align: center;
    span{
      font-size: 16px;
    }
  }
  .g-elmenu {
    /deep/ .el-menu{
      background-color: transparent;
    }
    /deep/ .el-submenu__title:hover{
      background-color: $green !important;
    }
    /deep/ .el-menu-item:hover{
      background-color: $green !important;
    }
  }
  
  .el-submenu__title p{
    position: absolute;
    right: 50px;
    top: 50%;
    margin-top: -10px;
    height: 20px;
    min-width: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 10px;
    border: 1px solid $fc;
    background: $red;
  }

  .el-submenu .el-menu-item,.el-submenu .el-submenu__title {
    height: 40px;
    line-height: 40px;
    // border-left: 3px solid $bg;
    font-size: 14px;
    padding-left: 64px !important;
    
  }

  .el-menu-item span, .el-submenu__title span, .el-submenu__title i {
    font-size: 14px;
    color: $fc;
  }

  .el-menu-item .iconfont, .el-submenu__title .iconfont {
    color: $fc;
    margin-right: 10px;
    font-size: 18px;
  }

  .el-menu-item.is-active, .el-submenu__title.is-active {
    background-color: $green !important;
  }

  .el-menu-item.is-active span, .el-submenu__title.is-active span {
    color: $fc;
  }

  .el-menu-item.is-active i, .el-submenu__title.is-active i {
    margin-right: 10px;
    font-size: 14px;
    color: $fc;
  }

  .g-elmenu .is-opened .el-submenu__title span {
    color: $fc;
  }
</style>



// WEBPACK FOOTER //
// src/components/left-navbar.vue